import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#ABB9BF",
      d: "M0 16 15.5.5l1.414 1.414-15.5 15.5z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#ABB9BF",
      d: "m1.414.5 15.5 15.5-1.414 1.414L0 1.914z"
    }, null, -1)
  ])))
}
export default { render: render }